import { CoreReason } from "./reason-code.js";
/**
 * The engine's own codes, described. Polish, because these are read in the back
 * office's reason filter — the code itself stays the English identifier that
 * apiClients branch on and the audit log stores.
 */
export const CORE_REASON_DESCRIPTORS = [
    { code: CoreReason.nip_invalid, description: "Błędny identyfikator, odrzucony na wejściu" },
    {
        code: CoreReason.no_applicable_rule,
        description: "Żadna włączona reguła nie obsługuje tego kraju",
    },
    { code: CoreReason.quota_exhausted, description: "Pula zapytań płatnego źródła wyczerpana" },
    { code: CoreReason.provider_unavailable, description: "Provider nie odpowiedział albo padł" },
    { code: CoreReason.manual_override, description: "Człowiek podstawił tę decyzję" },
    {
        code: CoreReason.rule_conditions_unmet,
        description: "Reguła pominięta — kontekst zapytania nie spełnił jej warunków",
    },
];
//# sourceMappingURL=core-reasons.js.map